import { IVisualCardWithConfig } from '@seb/web-design-system/visual-cards';
import { ThemesEnum } from '@seb/web-design-system/core';

import { richParagraphSkeleton } from '../../models/skeleton/rich-paragraph.skeleton';

export const visualCardWithConfigSkeleton: IVisualCardWithConfig = {
  themesConfig: ThemesEnum.light,
  card: { content: { heading: richParagraphSkeleton.heading } }
};
